/* eslint-disable */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Input, Button, Card, Space, Typography, Row, Col, message, InputNumber } from 'antd';
import { SaveOutlined, ReloadOutlined, SendOutlined, MailOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { TextArea } = Input;

function APISettingEmail(props) {
  const [configForm] = Form.useForm();
  const [testForm] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [testLoading, setTestLoading] = useState(false);

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    api_read_emailconfig();
  }, []);

  async function api_read_emailconfig() {
    setLoading(true);
    await sleep(500);

    const formData = new FormData();
    axios
      .post(props.app_hostname + '/api/account/setting/email/readconfig', formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setLoading(false);
        if (response.data.status === 'OK') {
          configForm.setFieldsValue({
            'smtp-server': response.data.apidata.smtp_server,
            'smtp-port': response.data.apidata.smtp_port,
            'smtp-mailsender': response.data.apidata.smtp_mailsender,
            'smtp-mailpasword': response.data.apidata.smtp_mailpasword,
          });
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาดในการโหลดการตั้งค่า');
        }
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  async function api_save_emailconfig(values) {
    setLoading(true);
    await sleep(500);

    const formData = new FormData();
    formData.append('smtp-server', values['smtp-server']);
    formData.append('smtp-port', values['smtp-port']);
    formData.append('smtp-mailsender', values['smtp-mailsender']);
    formData.append('smtp-mailpasword', values['smtp-mailpasword']);

    axios
      .post(props.app_hostname + '/api/account/setting/email/saveconfig', formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setLoading(false);
        if (response.data.status === 'OK') {
          configForm.setFieldsValue({
            'smtp-server': response.data.apidata.smtp_server,
            'smtp-port': response.data.apidata.smtp_port,
            'smtp-mailsender': response.data.apidata.smtp_mailsender,
            'smtp-mailpasword': response.data.apidata.smtp_mailpasword,
          });
          message.success('บันทึกการตั้งค่าอีเมลสำเร็จ');
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาดในการบันทึกการตั้งค่า');
        }
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  async function api_Send_emailmessage(values) {
    setTestLoading(true);
    await sleep(500);

    const formData = new FormData();
    formData.append('email-to', values['email-to']);
    formData.append('email-subject', values['email-subject']);
    formData.append('email-message', values['email-message']);

    axios
      .post(props.app_hostname + '/api/account/tester/email/sendmessage', formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setTestLoading(false);
        if (response.data.status === 'OK') {
          message.success('ส่งอีเมลทดสอบสำเร็จ');
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาดในการส่งอีเมล');
        }
      })
      .catch((err) => {
        setTestLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  return (
    <div className='page-card'>
      <Space direction='vertical' size='large' style={{ width: '100%' }}>
        <Card type='inner' title='ตั้งค่าอีเมล'>
          <Form form={configForm} layout='vertical' onFinish={api_save_emailconfig}>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name='smtp-server'
                  label='เซิร์ฟเวอร์ SMTP (SMTP Server)'
                  rules={[{ required: true, message: 'กรุณากรอกเซิร์ฟเวอร์ SMTP' }]}
                >
                  <Input size='large' placeholder='smtp.example.com' />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name='smtp-port'
                  label='พอร์ต SMTP (SMTP Port)'
                  rules={[{ required: true, message: 'กรุณากรอกพอร์ต SMTP' }]}
                >
                  <InputNumber
                    size='large'
                    style={{ width: '100%' }}
                    min={1}
                    max={65535}
                    placeholder='587'
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name='smtp-mailsender'
                  label='อีเมลผู้ส่ง (Sender Email)'
                  rules={[
                    { required: true, message: 'กรุณากรอกอีเมลผู้ส่ง' },
                    { type: 'email', message: 'รูปแบบอีเมลไม่ถูกต้อง' },
                  ]}
                >
                  <Input size='large' prefix={<MailOutlined />} placeholder='sender@example.com' />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name='smtp-mailpasword'
                  label='รหัสผ่านอีเมลผู้ส่ง'
                  rules={[{ required: true, message: 'กรุณากรอกรหัสผ่าน' }]}
                >
                  <Input.Password size='large' placeholder='รหัสผ่าน' />
                </Form.Item>
              </Col>
            </Row>
            <Space>
              <Button type='primary' htmlType='submit' icon={<SaveOutlined />} loading={loading}>
                บันทึกการตั้งค่า
              </Button>
              <Button icon={<ReloadOutlined />} onClick={api_read_emailconfig}>
                รีเฟรช
              </Button>
            </Space>
          </Form>
        </Card>

        <Card type='inner' title='เครื่องมือทดสอบส่งอีเมล'>
          <Form form={testForm} layout='vertical' onFinish={api_Send_emailmessage}>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name='email-to'
                  label='ส่งถึงอีเมล'
                  rules={[
                    { required: true, message: 'กรุณากรอกอีเมลผู้รับ' },
                    { type: 'email', message: 'รูปแบบอีเมลไม่ถูกต้อง' },
                  ]}
                >
                  <Input
                    size='large'
                    prefix={<MailOutlined />}
                    placeholder='recipient@example.com'
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name='email-subject'
                  label='หัวข้ออีเมล'
                  rules={[{ required: true, message: 'กรุณากรอกหัวข้ออีเมล' }]}
                >
                  <Input size='large' placeholder='หัวข้ออีเมล' />
                </Form.Item>
              </Col>
              <Col xs={24}>
                <Form.Item
                  name='email-message'
                  label='ข้อความอีเมล'
                  rules={[{ required: true, message: 'กรุณากรอกข้อความอีเมล' }]}
                >
                  <TextArea
                    size='large'
                    autoSize={{ minRows: 4, maxRows: 20 }}
                    placeholder='พิมพ์ข้อความอีเมลที่นี่...'
                  />
                </Form.Item>
                <Button
                  type='primary'
                  htmlType='submit'
                  icon={<SendOutlined />}
                  loading={testLoading}
                >
                  ส่งอีเมล
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </Space>
    </div>
  );
}

export default APISettingEmail;
